import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BroadcastMessageService {
  public broadcastChannel = new BroadcastChannel('qober-channel');

  constructor() { }
}